import _ from 'lodash';
import request from 'superagent';
import * as constants from '../../constants/apiCallsConstants';


function mapResponseToData(response, filters) {
  return response.body;
}

function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'Application is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra,
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || [],
  };
}

function requestApiCallsDetails(params) {
  return {
    type: constants.REQUEST_API_CALLS_DETAILS,
    params,
  };
}

function requestApiCallsPeriods(params) {
  return {
    type: constants.REQUEST_API_CALLS_SUMMARY,
    params,
  };
}

function receiveApiCallsDetails(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: constants.RECEIVE_API_CALLS_DETAILS,
    usage: data.usage,
    periods: filters.periods,
    status: data.status,
  };
}

function receiveApiCallsPeriods(response, filters) {
  const data = mapResponseToData(response, filters);

  return {
    type: constants.RECEIVE_API_CALLS_SUMMARY,
    usage: filters.usage,
    periods: data.periods,
    status: data.status,
  };
}

function receiveError(err, msg) {
  return {
    type: constants.SERVICE_ERROR,
    error: msg,
    errors: msg,
  };
}

function onFailure(dispatch) {
  return function (err) {
    return dispatch(receiveError(constants.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
  };
}

// exports
export const getApiCallsDetails = params => function (dispatch) {
  dispatch(requestApiCallsDetails(params));

  return request
    .get(`/rpc/integrations/${params.uid}/billing_usage?period_start=${params.period_start}&period_end=${params.period_end}&interval_grouping=${params.interval_grouping}`)
    .set('Accept', 'application/json')
    .then(
      response => dispatch(receiveApiCallsDetails(response, params)),
      onFailure(dispatch),
    );
};

export const getApiCallsSummary = params => function (dispatch) {
  dispatch(requestApiCallsPeriods(params));

  return request
    .get(`/rpc/integrations/${params.uid}/billing_periods`)
    .set('Accept', 'application/json')
    .then(
      response => dispatch(receiveApiCallsPeriods(response, params)),
      onFailure(dispatch),
    );
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/integrationsActions.js
 **/